import { CartSubmitData } from "./cart-submit-data";
import { parseCookie } from "./cookie";
import { Guid } from "./guid";
import { UrlHelper } from "./url-helper";

export class ShopifyClient {
    public constructor(private _shopifyClientSettings: { cartUrl: string }) { } 

    public changeLineItem(data: CartSubmitData) {
        const changeAddress = this.buildChangeLineItemAddress();

        return this._post(changeAddress, data);
    }

    public async addToCart(data: CartSubmitData): Promise<{response: any, responseText: string}> {
        const submitAddress = this.buildSubmitCartAddress();
        return this._post(submitAddress, data);
    }

    public goToCartPage() {
        location.href = this._shopifyClientSettings.cartUrl;
    }    

    public buildStorefrontUserId(shopDomain: string, customerId?: string) {
        const isAnonymousUser = customerId == null;

        return isAnonymousUser ? this.buildAnonymousStorefrontUserId() : this.buildSignedInStorefrontUserId(shopDomain, customerId); 
    }

    public getCurrentProductQuantity() : number {

        let url = document.location.href;
        var queryParams = this.getQueryParameters(url);
        var quantity = queryParams['quantity'] ? Number(queryParams['quantity']) : null;

        
        if(!quantity) {
            quantity = !queryParams ? queryParams['quantity'] : 1;
        }

        return quantity
    }

    private getQueryParameters(str: string) {
        var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function(n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
        delete result[""];

        Object.keys(result).forEach(function(key) {
            result[key] = decodeURIComponent(result[key]);
        });

        if (Object.keys(result).length == 0 && result.constructor === Object) {
            result = {};
        }

        return result;
    }

    private buildSignedInStorefrontUserId(shopDomain: string, customerId: string) {
        const firstDomainSegment = shopDomain.split('.')[0];

        return `shopify_${firstDomainSegment}_${customerId}`;
    }

    private buildAnonymousStorefrontUserId() {
        return `shopify_${this.getSessionId()}`;
    }

    private getSessionId(): string {
        var cookie = parseCookie(document.cookie);

        return cookie["_shopify_y"]
            || cookie["_y"]
            || cookie["_shopify_s"]
            || cookie["_s"]
            || cookie["__ssid"]
            || Guid.new();
    }

    private buildChangeLineItemAddress() {
        if (UrlHelper.isAbsolute(this._shopifyClientSettings.cartUrl)) {
            return UrlHelper.urlCombine(this._shopifyClientSettings.cartUrl, 'change.js').toString();
        }
        else {
            return UrlHelper.relativeUrlCombine(this._shopifyClientSettings.cartUrl, 'change.js');
        }
    }

    private buildSubmitCartAddress() {
        if (UrlHelper.isAbsolute(this._shopifyClientSettings.cartUrl)) {
            return UrlHelper.urlCombine(this._shopifyClientSettings.cartUrl, 'add.js').toString();
        }
        else {
            return UrlHelper.relativeUrlCombine(this._shopifyClientSettings.cartUrl, 'add.js');
        }
    }

    private _post(url: string, data: any): Promise<{response: any, responseText: string}> {
        return new Promise((resolve, fail) => {
            let xhr = new XMLHttpRequest();
            xhr.onerror = fail;
            xhr.onabort = fail;
            xhr.ontimeout = fail;
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== XMLHttpRequest.DONE) {
                    return;
                }
                let inRange = (lower, upper, val) => val >= lower && val < upper;
                if (inRange(200, 300, xhr.status)) {
                    resolve({ response: xhr.response, responseText: xhr.responseText});
                } else {
                    fail({ response: xhr.response,responseText: xhr.responseText,readyState: xhr.readyState});
                }
            };
            xhr.open('post', url, true);
            if (typeof (data) !== 'string') {
                data = this.JSON_to_URLEncoded(data);
            }
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.send(data);
        });
    }

    private JSON_to_URLEncoded(element, key = null, list = []) {
        list = list || [];
        if (typeof (element) === "object") {
            for (let idx in element) {
                if (element.hasOwnProperty(idx))
                    this.JSON_to_URLEncoded(element[idx], key ? key + "[" + idx + "]" : idx, list);
            }
        } else {
            list.push(key + "=" + encodeURIComponent(element));
        }
        return list.join("&");
    }      
}